<template>
  <div class="print-pay-fee-container">
    <div style="display: flex; align-items: center; justify-content: space-between;">
      <div style="margin-left: 20px;">
        <img src="/img/wy_logo.png" width="300" height="96">
      </div>
      <div style="text-align: center; flex: 1;font-weight: bold;">
          <div style="color:#000;font-size:25px;margin-left:-200px;">
            {{printPayFeeInfo.communityName}}
          </div>  
          <span style="font-weight: bold;font-size:20px;margin-left:-200px;">{{ $t('printPayFee.receipt') }}</span>
      </div>
    </div>
    <div style="color:#000;font-size:18px;margin-left:20px">
      <div class="float-left">
        <span></span>
        <br />
      </div>
      <div class="float-right text-right">
        <span>{{ $t('printPayFee.receiptNum') }}：{{printPayFeeInfo.receiptNum}}</span>
        <br />
        <span>{{ $t('printPayFee.payTime') }}：{{printPayFeeInfo.feeTime}}</span>
      </div>
    </div>
    <table class="table vc-table-border" style="color:#000;font-size:20px;width:100%;border-collapse:collapse;">
      <tr class="vc-table-border">
        <td class="text-center" style="width:15%">{{ $t('printPayFee.owner') }}</td>
        <td class="text-center" style="width:18%">{{printPayFeeInfo.payObjName}}</td>
        <td class="text-center" style="width:15%">{{ $t('printPayFee.houseCar') }}</td>
        <td class="text-center" style="width:18%">{{printPayFeeInfo.roomName}}</td>
        <td class="text-center" style="width:15%">{{ $t('printPayFee.areaUsage') }}</td>
        <td class="text-center" style="width:18%">{{printPayFeeInfo.fees[0].area}}</td>
      </tr>
      <tr class="vc-table-border">
        <td class="text-center">{{ $t('printPayFee.feeItem') }}</td>
        <td class="text-center">{{printPayFeeInfo.fees[0].feeName}}</td>
        <td class="text-center">{{ $t('printPayFee.feeRange') }}</td>
        <td class="text-center" colspan="3">
          <div v-if="printPayFeeInfo.fees[0].preDegrees">
            {{mergedFeeRange()}}
            <div v-if="printPayFeeInfo.fees.length === 1">
              <br />
              {{printPayFeeInfo.fees[0].preDegrees}} {{ $t('printPayFee.to') }} {{printPayFeeInfo.fees[0].curDegrees}}
            </div>
          </div>
          <div v-else-if="printPayFeeInfo.fees[0].feeTypeCd === '888800010006'">
            {{ $t('printPayFee.none') }}
          </div>
          <div v-else>
            {{mergedFeeRange()}}
          </div>
        </td>
      </tr>
      <tr class="vc-table-border">
        <td class="text-center">{{ $t('printPayFee.paymentMethod') }}</td>
        <td class="text-center">{{printPayFeeInfo.fees[0].primeRate}}</td>
        <td class="text-center">{{ $t('printPayFee.unitPrice') }}</td>
        <td class="text-center">{{printPayFeeInfo.fees[0].squarePrice}}</td>
        <td class="text-center">{{ $t('printPayFee.capitalrmb') }}</td>
        <td class="text-center">{{printPayFeeInfo.amount}}</td>
      </tr>
      <tr class="vc-table-border">
        <td class="text-center">{{ $t('printPayFee.capitalRMB') }}</td>
        <td class="text-left" colspan="5">{{changeNumMoneyToChinese(printPayFeeInfo.amount)}}</td>
      </tr>
      <tr class="vc-table-border">
        <td class="text-center">{{ $t('printPayFee.remark') }}</td>
        <td class="text-left" colspan="5">{{mergedRemark()}}</td>
      </tr>
    </table>

    <el-row style="color:#000;font-size:20px;margin-left: 10px;" class="flex justify-between">
      <el-col style="text-align: left;width:50%;" :span="3">{{ $t('printPayFee.hz') }}</el-col>
      <el-col style="text-align: left;width:60%;" :span="4">{{ $t('printPayFee.kj') }}</el-col>
      <el-col style="text-align: left;width:60%;" :span="4">{{ $t('printPayFee.jz') }}</el-col>
      <el-col style="text-align: left;width:70%;" :span="5">{{ $t('printPayFee.cn') }}</el-col>
      <el-col style="text-align: left;" :span="7">{{ $t('printPayFee.operator') }}{{userInfo.name}}</el-col>
    </el-row>

    <el-row id="print-btn">
      <el-col :span="24">
        <el-button type="primary" class="float-right" @click="handlePrint">
          <i class="el-icon-printer"></i>&nbsp;{{ $t('common.print') }}
        </el-button>
        <el-button type="warning" class="float-right" style="margin-right:20px;" @click="handleClose">
          {{ $t('common.cancel') }}
        </el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getCommunityId, getCommunityName } from '@/api/community/communityApi'
import { queryFeeReceipt, queryFeeReceiptDetail, queryFeePrintSpec } from '@/api/fee/printPayFeeApi'
import { getUserId, getUserName } from '@/api/user/userApi'
import { dateFormat } from '@/utils/dateUtil'
import { changeNumMoneyToChinese } from '@/utils/moneyUtil' 

export default {
  name: 'PrintPayFeeList',
  data() {
    return {
      printPayFeeInfo: {
        communityName: '',
        receiptId: '',
        receiptIds: '',
        detailIds: '',
        roomName: '',
        amount: 0.00,
        fees: [{ objName: '',roomName: '', area: '', feeName: '', preDegrees: '', startTime: '', endTime: '', curDegrees: '', feeTypeCd: '', primeRate: '', squarePrice: '', remark: '' }],
        feeTime: '',
        wechatName: '',
        content: '',
        qrImg: '',
        payObjName: '',
        feeReceipt: [],
        apply: 'N',
        receiptNum: '',
        acctAmount: 0
      },
      userInfo: {},
      printFlag: '0',
      communityId: ''
    }
  },
  created() {
    console.log('=== printPayFeeList created ===')
    this.communityId = getCommunityId()
    this.userInfo = {
      userId: getUserId(),
      name: getUserName()
    }
    this.initData()
  },
  methods: {
    initData() {
      this.printPayFeeInfo.receiptId = this.$route.query.receiptId
      this.printPayFeeInfo.receiptIds = this.$route.query.receiptIds
      this.printPayFeeInfo.detailIds = this.$route.query.detailIds
      if(this.$route.query.apply){
        this.printPayFeeInfo.apply = this.$route.query.apply
      }
      this.printPayFeeInfo.merge = this.$route.query.merge
      this.printPayFeeInfo.communityName =  getCommunityName()

      this.loadReceipt()
      this.loadPrintSpec()
    },
    loadReceipt() {
      const receiptIds = (this.printPayFeeInfo.receiptIds || '').split(',').filter(id => id)
      const receiptIdArr = this.printPayFeeInfo.receiptId && !receiptIds.includes(this.printPayFeeInfo.receiptId)
        ? [...receiptIds, this.printPayFeeInfo.receiptId]
        : receiptIds
      // 批量缴费自动跳转时只传 detailIds，需按 detailIds 数量计算分页，避免只返回前 30 条导致金额缺失
      const detailIds = (this.printPayFeeInfo.detailIds || '').split(',').filter(id => id)
      const params = {
        page: 1,
        row: Math.max(30, receiptIdArr.length, detailIds.length),
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId
      }

      queryFeeReceipt(params).then(response => {
        const feeReceipt = response.data
        if (!feeReceipt || feeReceipt.length < 1) {
          this.$message.warning('未查询到收据信息')
          return
        }
        let amount = 0
        const seenReceiptIds = new Set()
        feeReceipt.forEach(item => {
          // 按 receiptId 去重：SQL 关联明细可能导致同一收据返回多条，避免金额重复累加
          if (!seenReceiptIds.has(item.receiptId)) {
            amount += parseFloat(item.amount)
            seenReceiptIds.add(item.receiptId)
          }
        })

        this.printPayFeeInfo.amount = amount.toFixed(2)
        this.printPayFeeInfo.roomName = feeReceipt[0].roomName
        this.printPayFeeInfo.feeTime = feeReceipt[0].createTime
        this.printPayFeeInfo.payObjName = feeReceipt[0].payObjName
        this.printPayFeeInfo.feeReceipt = feeReceipt
        this.printPayFeeInfo.receiptNum = feeReceipt[0].receiptCode
		this.printPayFeeInfo.communityName = feeReceipt[0].storeName

        this.loadReceiptDetail()
      })
    },
    loadReceiptDetail() {
      const receiptIds = (this.printPayFeeInfo.receiptIds || '').split(',').filter(id => id)
      const receiptIdArr = this.printPayFeeInfo.receiptId && !receiptIds.includes(this.printPayFeeInfo.receiptId)
        ? [...receiptIds, this.printPayFeeInfo.receiptId]
        : receiptIds
      const detailIds = (this.printPayFeeInfo.detailIds || '').split(',').filter(id => id)
      const params = {
        page: 1,
        row: Math.max(100, receiptIdArr.length + detailIds.length),
        receiptId: this.printPayFeeInfo.receiptId,
        receiptIds: this.printPayFeeInfo.receiptIds,
        detailIds: this.printPayFeeInfo.detailIds,
        communityId: this.communityId,
        mergeFee: this.printPayFeeInfo.merge
      }

      queryFeeReceiptDetail(params).then(response => {
        const feeReceiptDetails = response.data
        if (!feeReceiptDetails || feeReceiptDetails.length < 1) {
          this.$message.warning('未查询到收据明细信息')
          return
        }
        this.printPayFeeInfo.receiptNum = this.printPayFeeInfo.receiptNum + "(" + feeReceiptDetails[0].payOrderId + ")"
        if (feeReceiptDetails[0].amount < 0) {
          this.printPayFeeInfo.apply = 'R'
        }
        let acctAmount = 0.0
        const parkingFeeTypes = ['888800010008', '888800010002', '888800010003', '888800010004', '888800010005', '888800010006', '888800010007']
        feeReceiptDetails.forEach(item => {
          if (item.feeName) {
            item.feeName = item.feeName.replace(/导入/g, '')
          }
          acctAmount = acctAmount + parseFloat(item.acctAmount)
          this.printPayFeeInfo.feeReceipt.forEach(im => {
            if (item.receiptId == im.receiptId) {
              item.objName = im.objName
              item.feeTypeCd = im.feeTypeCd
            }
          })
          if (parkingFeeTypes.includes(item.feeTypeCd)) {
            item.squarePrice = item.amount
          }
        })
        this.printPayFeeInfo.fees = feeReceiptDetails
        this.printPayFeeInfo.acctAmount = acctAmount.toFixed(2)
      })
    },
    loadPrintSpec() {
      const params = {
        page: 1,
        row: 1,
        specCd: 2020,
        communityId: this.communityId
      }

      queryFeePrintSpec(params).then(response => {
        const data = response.data
        if (data.length > 0) {
          this.printPayFeeInfo.content = data[0].content
          this.printPayFeeInfo.qrImg = data[0].qrImg
          if (data[0].printName) {
            this.printPayFeeInfo.communityName = data[0].printName
          }
        }
      })
    },
    dateFormat(date) {
      if (!date) return ''
      return dateFormat(date)
    },
    changeNumMoneyToChinese,
    handlePrint() {
      this.printFlag = '1'
      document.getElementById("print-btn").style.display = "none"
      setTimeout(() => {
        window.print()
        window.close()
      }, 100)
    },
    handleClose() {
      window.close()
    },
    // 提取日期部分 YYYY-MM-DD（避免 new Date 时区问题）
    extractDate(str) {
      if (!str) return ''
      return String(str).substring(0, 10)
    },
    // 计算某个日期的次日（传入 YYYY-MM-DD，返回 YYYY-MM-DD）
    getNextDay(dateStr) {
      const [year, month, day] = dateStr.split('-').map(Number)
      const date = new Date(year, month - 1, day)
      date.setDate(date.getDate() + 1)
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
    },
    // 判断两个单日期是否是连续的月份（如 2026-08-31 和 2026-09-30）
    isNextMonth(curDateStr, nextDateStr) {
      const [y, m] = curDateStr.split('-').map(Number)
      const nextMonthDate = new Date(y, m, 1)
      const nextMonthStr = `${nextMonthDate.getFullYear()}-${String(nextMonthDate.getMonth() + 1).padStart(2, '0')}`
      const nextItemMonth = nextDateStr.substring(0, 7)
      return nextMonthStr === nextItemMonth
    },
    // 合并费用期间：连续日期合并为首尾，不连续以逗号隔开
    mergedFeeRange() {
      const fees = this.printPayFeeInfo.fees
      if (!fees || fees.length === 0) return ''
      if (fees.length === 1) {
        const s = this.extractDate(fees[0].startTime)
        const e = this.extractDate(fees[0].endTime)
        if (s === e) {
          return this.dateFormat(fees[0].startTime)
        }
        return `${this.dateFormat(fees[0].startTime)}${this.$t('printPayFee.to')}${this.dateFormat(fees[0].endTime)}`
      }

      // 按 startTime 升序排序
      const sorted = [...fees].sort((a, b) => this.extractDate(a.startTime).localeCompare(this.extractDate(b.startTime)))

      const ranges = []
      let currentStart = sorted[0].startTime
      let currentEnd = sorted[0].endTime
      let currentIsSingle = this.extractDate(sorted[0].startTime) === this.extractDate(sorted[0].endTime)
      let currentCount = 1

      for (let i = 1; i < sorted.length; i++) {
        const item = sorted[i]
        const start = this.extractDate(item.startTime)
        const end = this.extractDate(item.endTime)
        const curEnd = this.extractDate(currentEnd)
        const isSingle = start === end

        let isContinuous = false
        if (!currentIsSingle && !isSingle) {
          // 都有完整区间，用日期连续判断
          const endNextDay = this.getNextDay(curEnd)
          isContinuous = start === endNextDay || start <= curEnd
        } else if (currentIsSingle && isSingle) {
          // 都是单日期（月末），用月份连续判断
          isContinuous = this.isNextMonth(curEnd, start)
        }
        // 混合类型（一个完整区间 + 一个单日期）不连续

        if (isContinuous) {
          currentEnd = item.endTime
          currentCount++
          if (!isSingle) currentIsSingle = false
        } else {
          ranges.push({ start: currentStart, end: currentEnd, isSingle: currentIsSingle, count: currentCount })
          currentStart = item.startTime
          currentEnd = item.endTime
          currentIsSingle = isSingle
          currentCount = 1
        }
      }
      ranges.push({ start: currentStart, end: currentEnd, isSingle: currentIsSingle, count: currentCount })

      return ranges.map(r => {
        const s = this.extractDate(r.start)
        const e = this.extractDate(r.end)
        if (r.isSingle && r.count > 1) {
          // 多条单日期（月末）合并：起始日期用第一条的当月1日
          const firstDay = s.substring(0, 7) + '-01'
          return `${this.dateFormat(firstDay)}${this.$t('printPayFee.to')}${this.dateFormat(r.end)}`
        }
        if (s === e) {
          return this.dateFormat(r.start)
        }
        return `${this.dateFormat(r.start)}${this.$t('printPayFee.to')}${this.dateFormat(r.end)}`
      }).join('，')
    },
    // 合并备注：按日期顺序，逗号隔开，相同内容去重
    mergedRemark() {
      const fees = this.printPayFeeInfo.fees
      if (!fees || fees.length === 0) return ''
      if (fees.length === 1) return fees[0].remark || ''

      // 按 startTime 升序排序
      const sorted = [...fees].sort((a, b) => this.extractDate(a.startTime).localeCompare(this.extractDate(b.startTime)))

      const remarks = []
      const seen = new Set()

      sorted.forEach(item => {
        if (item.remark && !seen.has(item.remark)) {
          remarks.push(item.remark)
          seen.add(item.remark)
        }
      })

      return remarks.join('，')
    }
  }
}
</script>

<style scoped>
.print-pay-fee-container {
  padding: 20px;
}

.float-left {
  float: left;
}

.float-right {
  float: right;
}

.text-center {
  text-align: center;
}

.text-right {
  text-align: right;
}

.el-row {
  width: 100%;
  margin-bottom: 20px;
}

.el-col {
  width: 100%;
}

@media print {
  body {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
  }

  .print-pay-fee-container {
    padding: 8mm 10mm 0mm 15mm;
    width: 241mm;
    height: 93mm;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
  }

  .print-pay-fee-container img {
    width: 170px !important;
    height: 52px !important;
  }

  .print-pay-fee-container div,
  .print-pay-fee-container span,
  .print-pay-fee-container table {
    font-size: 15px !important;
    color: #000 !important;
  }

  .print-pay-fee-container > div:first-child div {
    font-size: 22px !important;
  }

  .print-pay-fee-container > div:first-child span {
    font-size: 18px !important;
  }

  .print-pay-fee-container [style*="margin-left:-200px"] {
    margin-left: 0 !important;
  }

  .print-pay-fee-container [style*="margin-left:20px"] {
    margin-left: 0 !important;
  }

  .print-pay-fee-container table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 5px;
    margin-bottom: 5px;
  }

  .print-pay-fee-container table td {
    padding: 5px;
    line-height: 1.6;
    border: 1px solid #333;
    text-align: center;
  }

  .print-pay-fee-container table td.text-left {
    text-align: left !important;
  }

  .print-pay-fee-container .el-row {
    margin-bottom: 0;
    margin-top: 5px;
  }

  #print-btn {
    display: none !important;
  }
}
</style>

<style>
@page {
  size: 241mm 93mm;
  margin: 0;
}
</style>